import { AxiosError } from "axios";

import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { Conteudo } from "../../interfaces/entities/SaudeBemEstar/Conteudos/Conteudo";
import { ConteudoAnexo } from "../../interfaces/entities/SaudeBemEstar/Conteudos/ConteudoAnexo";

export const getConteudos = async (): Promise<Conteudo[]> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/getconteudos", { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const getConteudo = async (idMatEducativo: string): Promise<Conteudo> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/getconteudo?idMatEducativo=" + idMatEducativo, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};


export const getConteudoAnexos = async (idMatEducativo: string): Promise<ConteudoAnexo[]> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/getanexos?idMatEducativo=" + idMatEducativo, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const getConteudoAnexo = async (idAnexo: string): Promise<ConteudoAnexo> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/getanexo?idAnexo=" + idAnexo, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

